// whoami.js — shared mutable identity cache.
//
// The dashboard's "who am I" identity (email, role, source,
// avatar) is fetched from /v1/me at boot + on 5-minute refresh
// + after account-page actions (avatar upload, email change).
// Several modules read or mutate this cache:
//
//   - bootstrap.js's loadAndRenderWhoami (boot + 5-min refresh)
//   - bootstrap.js's sidebar badge render
//   - account-page.js's renderAccountIdentityPanel (re-fetches if
//     not loaded yet; both reads + replaces the binding)
//   - account-page.js's avatar handlers (mutate the
//     avatar_data_url field in place after upload/delete)
//   - handoffs.js's compose form (reads via the AC_LEGACY bridge
//     for the "From" field default)
//
// Pre-Phase K this was a `let whoamiCache = null` inside the
// bootstrap IIFE, with a getter on the AC_LEGACY bridge.
// Moving it here lets the new account-page.js module mutate
// the same reference everyone else reads — no setter bridge
// indirection needed, just imports.
//
// API:
//   getWhoami()                 — current cache (object or null)
//   setWhoami(next)             — replace the binding (used by
//                                  the /v1/me fetch in loadAndRenderWhoami)
//   patchWhoami({ ...fields })  — shallow merge into the existing
//                                  cache; no-ops if cache is null
//
// `getWhoami()` returns the live reference, so callers can also
// mutate fields directly (`getWhoami().avatar_data_url = ...`).
// That's a footgun in general, but it preserves the pre-hoist
// semantics — the avatar upload handler relies on direct in-place
// mutation to update the cached preview without re-fetching.

let whoamiCache = null;

export function getWhoami() {
  return whoamiCache;
}

export function setWhoami(next) {
  whoamiCache = next;
}

export function patchWhoami(fields) {
  if (!whoamiCache) return;
  Object.assign(whoamiCache, fields);
}
